import script from "./termsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./termsOfService.vue?vue&type=script&setup=true&lang=js"

import "./termsOfService.vue?vue&type=style&index=0&id=77aac168&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77aac168"]])

export default __exports__